import { useTranslation } from 'react-i18next';
import DynamicTags from 'components/Fields/FieldInput/DynamicTags';
import { getDataQAForInput } from 'components/Inputs/helpers';

const ChangeTags = ({
  tagsToAdd,
  tagsToRemove,
  onAddTagsToAdd,
  onAddTagsToRemove,
  field,
  ...others
}) => {
  const { t } = useTranslation();

  return (
    <>
      <DynamicTags
        ref={null}
        value={tagsToAdd}
        onChange={onAddTagsToAdd}
        validate={() => true}
        objectId={null}
        error={false}
        handleUpdateFieldOption={() => {}}
        fieldType={field?.fieldType}
        field={field}
        label={t('Choose Tags to Add')}
        placeholder={t('Find Options to Add')}
        margin
        inModal
        menuInline
        {...getDataQAForInput('tags-to-add', 'dropdown')}
        {...others}
      />

      <DynamicTags
        ref={null}
        value={tagsToRemove}
        onChange={onAddTagsToRemove}
        validate={() => true}
        objectId={null}
        error={false}
        handleUpdateFieldOption={() => {}}
        fieldType={field?.fieldType}
        field={field}
        label={t('Choose Tags to Remove')}
        placeholder={t('Find Options to Remove')}
        inModal
        menuInline
        {...getDataQAForInput('tags-to-remove', 'dropdown')}
        {...others}
      />
    </>
  );
};

export default ChangeTags;
